<template>
    <div class="Cheap">
        <slot />
    </div>
</template>
